'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.5 4c2.35 0 4.19.5 5.5 1.5v14.56c0 .12-.05.24-.16.35-.11.09-.23.17-.34.17-.11 0-.19-.02-.25-.05-1.28-.69-2.87-1.03-4.75-1.03-2.05 0-3.88.5-5.5 1.5-1.34-1-3.17-1.5-5.5-1.5-1.66 0-3.25.36-4.75 1.07-.03.01-.07.01-.12.03-.04.01-.08.02-.13.02-.11 0-.23-.04-.34-.12a.475.475 0 0 1-.16-.35V5.5C2.34 4.5 4.18 4 6.5 4c2.33 0 4.16.5 5.5 1.5 1.34-1 3.17-1.5 5.5-1.5Zm0 2c-2.05 0-3.88.5-5.5 1.5C10.38 6.5 8.55 6 6.5 6c-1.29 0-2.46.17-3.5.5V18c1.14-.34 2.31-.5 3.5-.5 2.05 0 3.88.5 5.5 1.5 1.62-1 3.45-1.5 5.5-1.5 1.19 0 2.36.16 3.5.5V6.5c-1.04-.33-2.21-.5-3.5-.5Zm0 7.83c.79 0 1.63.08 2.5.24v1.5c-.62-.16-1.46-.24-2.5-.24-1.9 0-3.39.33-4.5.99v-1.69c1.17-.53 2.67-.8 4.5-.8Zm-11 0c1.83 0 3.33.27 4.5.8v1.69c-1.11-.66-2.6-.99-4.5-.99-1.04 0-1.88.08-2.5.24v-1.5c.87-.16 1.71-.24 2.5-.24Zm11-2.66c.79 0 1.63.07 2.5.23v1.5c-.62-.16-1.46-.24-2.5-.24-1.9 0-3.39.34-4.5.99v-1.69c1.29-.53 2.79-.79 4.5-.79Zm-11 0c1.71 0 3.21.26 4.5.79v1.69c-1.11-.65-2.6-.99-4.5-.99-1.04 0-1.88.08-2.5.24v-1.5c.87-.16 1.71-.23 2.5-.23Zm11-2.67c.79 0 1.63.08 2.5.23v1.55c-.74-.19-1.59-.28-2.5-.28-1.9 0-3.39.32-4.5 1V9.34c1.23-.56 2.73-.84 4.5-.84Zm-11 0c1.77 0 3.27.28 4.5.84V11c-1.11-.68-2.6-1-4.5-1-.91 0-1.76.09-2.5.28V8.73c.87-.15 1.71-.23 2.5-.23Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
});
var OpenBookOutline = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.OpenBookOutline = OpenBookOutline;